import { ApiProject, ApiQuickInsightResult } from "@incendium/api";
import { useProjectSharedState } from "Hooks/useSharedState";
import { listQuickInsightResults } from "../service";

const fetchQuickInsightResults = async (project: ApiProject) => {
  const quickInsightResults = await listQuickInsightResults(
    project.id as number,
  );
  return quickInsightResults;
};

export const useQuickInsightResults = () => {
  const { state, setState, loading, fetched } = useProjectSharedState(
    "quickInsightResults",
    [],
    fetchQuickInsightResults,
  );

  return {
    quickInsightResults: state as ApiQuickInsightResult[],
    setQuickInsightResults: setState as React.Dispatch<
      React.SetStateAction<ApiQuickInsightResult[]>
    >,
    loading,
    fetched,
  };
};
